import {
  DetailRecordPage,
  DownloadableResultsGuidePage,
  ShareFetalSexPage,
  TestResultDetailsPage,
  TestResultPdfPage,
  UnderstandingYourResultsPage,
} from "@app/pages";
import {
  DrawRequestProvider,
  HeapAnalyticDataProvider,
  TestResultProvider,
} from "@app/provider";
import React, { FC } from "react";
import { Route, Routes } from "react-router-dom";
import SupplementalPdf from "./supplemental/pdf/supplementalPdf";
import SupplementalVideo from "./supplemental/video/supplementalVideo";
import { TestInformationPage } from "@app/pages/private/testResult/testInformation";
import { TestDetailsProvider } from "@app/provider/testData";
import DelayedResultReleaseGuard from "@app/components/delayedResultReleaseGuard";

const TestResultPage: FC = () => {
  return (
    <TestDetailsProvider>
      <TestResultProvider>
        <HeapAnalyticDataProvider>
          <DrawRequestProvider>
            <Routes>
              {/* Routes gated when the test card is in PROCESSING (result release delayed). */}
              <Route element={<DelayedResultReleaseGuard />}>
                <Route
                  path="/:testStatus/:testDocumentUid/understanding-your-results/"
                  element={<UnderstandingYourResultsPage />}
                />
                <Route
                  path="/result-details"
                  element={<TestResultDetailsPage />}
                />
                <Route
                  path="/share-fetal-sex"
                  element={<ShareFetalSexPage />}
                />
                <Route
                  path="/result-pdf/:testDocumentUid"
                  element={<TestResultPdfPage />}
                />
              </Route>

              <Route path="/pdf/:uid" element={<SupplementalPdf />} />
              <Route path="/video/:uid" element={<SupplementalVideo />} />
              <Route
                path="/downloadable-results-guide/"
                element={<DownloadableResultsGuidePage />}
              />
              <Route
                path="/details/information"
                element={<TestInformationPage />}
              />
              <Route path="/details" element={<DetailRecordPage />} />
            </Routes>
          </DrawRequestProvider>
        </HeapAnalyticDataProvider>
      </TestResultProvider>
    </TestDetailsProvider>
  );
};

export default TestResultPage;
